import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default from 'react';
import '@costar-ui/cosmos';
import { ArticlePromoWithImage, ImageOrientation } from '../article-promo/article-promo-with-image.esm.js';
import { ArticlePreview } from '../atoms/article-preview/article-preview.esm.js';
import { ArticleTitle, ArticleTitleVariants } from '../atoms/article-title/article-title.esm.js';
import { CategoryBar } from '../atoms/category-bar/category-bar.esm.js';

var FeaturedArticle = function FeaturedArticle(_ref) {
  var articleTitleLink = _ref.articleTitleLink,
    articlePreviewLink = _ref.articlePreviewLink,
    articleImage = _ref.articleImage,
    categoryLink = _ref.categoryLink;
  var featuredArticleTitle = /*#__PURE__*/React__default.createElement(ArticleTitle, {
    headlineTag: 'h1',
    articleTitleVariant: ArticleTitleVariants.ArticleTitleXLarge
  }, articleTitleLink);
  var featuredArticlePreview = /*#__PURE__*/React__default.createElement(ArticlePreview, {
    className: "mx-4 line-clamp-[10] sm:line-clamp-5 lg:mx-0 lg:line-clamp-[14]"
  }, articlePreviewLink);
  var featuredArticleImage = /*#__PURE__*/React__default.createElement("div", {
    className: "relative aspect-3/2 w-full"
  }, articleImage);
  var categoryBarElement = /*#__PURE__*/React__default.createElement(CategoryBar, null, categoryLink);
  return /*#__PURE__*/React__default.createElement("article", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React__default.createElement(ArticlePromoWithImage, {
    articleTitleElement: featuredArticleTitle,
    categoryBarElement: categoryBarElement,
    imageElement: featuredArticleImage,
    articlePromoContainerStyle: "mx-4 lg:mx-0",
    imageOrientation: ImageOrientation.Top,
    className: "gap-4"
  }), featuredArticlePreview);
};
var SubArticles = function SubArticles(_ref2) {
  var articleTitleLink = _ref2.articleTitleLink,
    articleImage = _ref2.articleImage,
    categoryLink = _ref2.categoryLink;
  var newsTitle = /*#__PURE__*/React__default.createElement(ArticleTitle, {
    className: "text-p-16/5 sm:text-p-18/6 lg:text-p-16/5"
  }, articleTitleLink);
  var newsImage = /*#__PURE__*/React__default.createElement("div", {
    className: "relative hidden h-[80px] w-[120px] sm:block sm:shrink-0"
  }, articleImage);
  var categoryBarElement = /*#__PURE__*/React__default.createElement(CategoryBar, null, categoryLink);
  return /*#__PURE__*/React__default.createElement("article", {
    className: "col-span-6 gap-8 sm:max-lg:col-span-3"
  }, /*#__PURE__*/React__default.createElement(ArticlePromoWithImage, {
    articleTitleElement: newsTitle,
    categoryBarElement: categoryBarElement,
    imageElement: newsImage,
    imageOrientation: ImageOrientation.Side,
    className: "gap-0 sm:gap-4"
  }));
};
var TopNewsLayout = function TopNewsLayout(_ref3) {
  var featuredArticleComponents = _ref3.featuredArticleComponents,
    subarticlesComponents = _ref3.subarticlesComponents;
  var subArticles = /*#__PURE__*/React__default.createElement("div", {
    "automation-id": "subarticles",
    className: "col-span-5 mx-8 grid grid-cols-6 gap-4 lg:mx-0 sm:max-lg:mx-4 sm:max-lg:gap-6"
  }, subarticlesComponents.map(function (data, index) {
    return /*#__PURE__*/React__default.createElement(SubArticles, _extends({
      key: index
    }, data));
  }));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "col-span-5",
    "automation-id": "featured-article"
  }, /*#__PURE__*/React__default.createElement(FeaturedArticle, featuredArticleComponents)), subArticles);
};

export { TopNewsLayout };
//# sourceMappingURL=top-news-layout.esm.js.map
